import React, { useEffect } from 'react'
import LoggedInScaffolding from 'containers/LoggedInScaffolding'
import withAuthRouter from 'containers/AuthRouter'
import ProductsLayout from 'components/Products/Layout'
import {
    SubscriptionsSection,
    PassesSection,
    DonationBoxesSection,
} from 'containers/Products'

import { contributionBinPluralSlug, contributionBinPluralCapitalized } from 'features/ContributionLang'

export default withAuthRouter(({ router, stripe, integrationsLoading }) => {
    const { section } = router.query
    const hasStripeIntegration = stripe?.active

    useEffect(() => {
        if (!hasStripeIntegration && !integrationsLoading && integrationsLoading !== null) {
            // router.push('/settings/integrations/stripe')
        }
    }, [
        hasStripeIntegration,
        router,
        integrationsLoading,
    ])
    
    const products = {
        subscriptions: {
            title: 'Subscriptions',
        },
        passes: {
            title: 'Passes',
        },
        [contributionBinPluralSlug()]: {
            title: contributionBinPluralCapitalized(),
        },
    }

    const renderedComponents = {
        subscriptions: <SubscriptionsSection {...products[section]} />,
        passes: <PassesSection {...products[section]} />,
        [contributionBinPluralSlug()]: <DonationBoxesSection {...products[section]} />,
    }

    if (!hasStripeIntegration) {
        return null
    }

    return (
        <LoggedInScaffolding pageTitle="Products">
            <ProductsLayout showMenu={true}>
                {renderedComponents[section]}
            </ProductsLayout>
        </LoggedInScaffolding>
    )
})
